import React, { useState } from "react";
import Deal from "./Deal";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "react-headless-accordion";
import { IoIosArrowBack } from "react-icons/io";

const Deals = () => {
  const whatsappNumber = "+972549432343"; // WhatsApp number
  const message = `היי, התעניינתי בדיל שבת חתן`;
  const message1 = `היי, התעניינתי באירוע הכל כלול עם בופה חופשי`;
  const message2 = `היי, התעניינתי בדיל בת/ בר מצווה`;

  const [rotationStates, setRotationStates] = useState({});
  const accordionTransitionDuration = 800; // Set the same duration as the accordion transition

  const toggleRotation = (accordionIndex) => {
    setRotationStates((prevState) => ({
      ...prevState,
      [accordionIndex]: !prevState[accordionIndex],
    }));
  };

  const handleWhatsAppClick = () => {
    const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappLink, "_blank");
  };

  const handleWhatsAppClick1 = () => {
    const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      message1
    )}`;
    window.open(whatsappLink, "_blank");
  };

  const handleWhatsAppClick2 = () => {
    const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      message2
    )}`;
    window.open(whatsappLink, "_blank");
  };
  const deals = [
    {
      headline: "דיל בסיס",
      info: "5 סוגי סלטים\n2 תוספות חמות לבחירה\nפילה מושט (אפוי / מטוגן / ברוטב) בתפזורת או בחמגשית",
      price: 50,
      min: "לחמניות מתנה למינימום 50 מנות",
    },
    {
      headline: "דיל בסיס פלוס",
      info: "6 סוגי סלטים\n3 תוספות חמות\n3 מנות עיקריות לבחירה",
      price: 65,
      min: "מינימום 30 מנות",
    },

    {
      headline: "דיל מתקדם",
      info: "7 סוגי סלטים\nמנה ראשונה       \n3 תוספות חמות\n3 מנות עיקריות לבחירה ",
      price: 80,
      min: "מינימום 30 מנות",
    },

    // Add more deals here
  ];
  return (
    <div className="py-16">
      {deals.map((deal, index) => (
        <Deal
          key={index}
          headline={deal.headline}
          info={deal.info}
          price={deal.price}
          min={deal.min}
        />
      ))}

      <div className="max-w-[90%] lg:max-w-[60%]  mx-auto my-8 px-2 shadow-2xl shadow-orange-50 bg-transparent border-2 text-white rounded-3xl  z-10">
        <div className="flex flex-col p-6 space-y-8">
          <div className="flex justify-between items-start">
            <h3
              dir="rtl"
              className="gold-text bg-black text-sm font-bold rounded-lg"
            >
              185 ש"ח למנה
            </h3>
            <h3
              dir="rtl"
              className="gold-text bg-black text-sm font-bold rounded-lg"
            >
              מינימום 40 הזמנות
            </h3>
          </div>
          <h2 className="text-2xl font-bold text-center">דיל שבת חתן</h2>

          <Accordion
            className="hover:opacity-95 card text-textBtn border-2 border-[#f3dbbb]  text-2xl font-semibold p-4"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: "cubic-bezier(0, 0, 0.2, 1)",
            }}
          >
            <AccordionItem>
              <AccordionHeader
                className="items-center flex justify-between"
                onClick={() => toggleRotation(1)}
              >
                <IoIosArrowBack
                  className={rotationStates[1] ? "rotate-90" : ""}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                  color="#fff"
                />
                <h3 className={`accordion-title  text-white`}>שישי ערב</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-white ">
                <div className="accordion-body">
                  <div className="card  mx-auto text-right ">
                    <div
                      dir="rtl"
                      className="text-lg font-medium text-right mt-2"
                    >
                      <p className="text-base mb-1">7 סוגי סלטים</p>

                      <p className="text-base mb-1 ">מנה ראשונה</p>
                      <p className="text-base mb-1">3 תוספות</p>
                      <p className="text-base mb-1">3 עיקריות</p>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <Accordion
            className="hover:opacity-95 card text-textBtn border-2 border-[#f3dbbb]  text-2xl font-semibold p-4"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: "cubic-bezier(0, 0, 0.2, 1)",
            }}
          >
            <AccordionItem>
              <AccordionHeader
                className="items-center flex justify-between"
                onClick={() => toggleRotation(21)}
              >
                <IoIosArrowBack
                  className={rotationStates[21] ? "rotate-90" : ""}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                  color="white"
                />
                <h3 className={`accordion-title  text-white`}>שבת צהריים</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-white">
                <div className="accordion-body">
                  <div className="card  mx-auto text-right ">
                    <div
                      dir="rtl"
                      className="text-lg text-right font-medium mt-2"
                    >
                      <p className="text-base mb-1">7 סוגי סלטים</p>

                      <p className="text-base mb-1">3 תוספות חמות</p>
                      <p className="text-base mb-1">3 מנות עיקריות</p>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          <Accordion
            className="hover:opacity-95 card text-textBtn border-2 border-[#f3dbbb]  text-2xl font-semibold p-4"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: "cubic-bezier(0, 0, 0.2, 1)",
            }}
          >
            <AccordionItem>
              <AccordionHeader
                className="items-center flex justify-between"
                onClick={() => toggleRotation(3)}
              >
                <IoIosArrowBack
                  className={rotationStates[3] ? "rotate-90" : ""}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                  color="white"
                />
                <h3 className={`accordion-title  text-white`}>סעודה שלישית</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-white">
                <div className="accordion-body">
                  <div className="card  mx-auto text-right font-medium ">
                    <div dir="rtl" className="text-lg text-right mt-2">
                      <p className="text-base mb-1">7 סוגי סלטים</p>

                      <p className="text-base mb-1">פילה מושט ברוטב</p>
                      <p className="text-base mb-1">
                        פשטידת ירקות / פטריות / בצל
                      </p>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          <p className="text-sm text-center ">
            כל האוכל מגיע בתבניות מתאימות לחימום בפלטה
          </p>

          <button
            onClick={handleWhatsAppClick}
            className="mt-4 mx-auto rounded-full flex items-center border-4 py-2 bg-gradient-to-l from-black to-[#333] text-textSave px-7  hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
          >
            <span
              className="gold-text bg-black text-base mb-1 font-black"
              dir="rtl"
            >
              אני רוצה להזמין!
            </span>
          </button>
          <p className="text-xs text-right">
            משלוח לאירוע (קר) 150 ש"ח - מגיע למקום האירוע ביום שישי בשעות הבוקר{" "}
          </p>
        </div>
      </div>

      <div className="max-w-[90%] lg:max-w-[60%]  mx-auto my-8 px-2 shadow-2xl shadow-orange-50 bg-transparent border-2 text-white rounded-3xl  z-10">
        <div dir="rtl" className="flex flex-col p-6 space-y-6">
          <div className="flex justify-between items-start">
            <h3
              dir="rtl"
              className="gold-text bg-black text-sm font-bold rounded-lg"
            >
              מינימום 50 הזמנות
            </h3>
            <h3
              dir="rtl"
              className="gold-text bg-black text-sm font-bold rounded-lg"
            >
              180 ש"ח למנה
            </h3>
          </div>

          <p className="text-base text-center ">
            יש לכם אירוע משפחתי? מזל טוב🙏🏼 רוצים לבוא כמו אורחים? אנחנו נטפל לכם
            בכל העניינים{" "}
          </p>

          <h2 className="text-2xl font-bold text-center">
            {" "}
            אירוע הכל כלול עם בופה חופשי
          </h2>
          <p className="text-sm text-center gold-text font-black">
            האוכל מוגש על סירי יציקה עם חימום קבוע ותיפעול שלנו כל הארוע
          </p>

          <h2 className="text-lg text-center font-black gold-text">
            הבופה כולל
          </h2>

          <h2 className="text-lg text-center">
            6 סוגי סלטים + סלט חסה וירקות עשיר
          </h2>
          <h2 className="text-lg text-center">
            עמדת לחמים: לחמניות / פרנות / פיתות
          </h2>
          <h2 className="text-lg text-center">3 תוספות חמות לבחירה</h2>
          <h2 className="text-lg text-center">
            3 מנות עיקריות לבחירה (כולל פרגית על האש ובשר מעושן)
          </h2>
          <h2 className="text-lg text-center">
            {" "}
            שולחנות ערוכים עם מפות צלחות סכום כוסות חד"פ איכותי{" "}
          </h2>
          <h2 className="text-lg text-center">
            בקבוקי שתיה מוגזים צלולים ומים
          </h2>
          <h2 className="text-lg text-center">(בירה / יין בתוספת תשלום)</h2>
          <h2 className="text-lg text-center ">שולחן קינוחים עשיר</h2>

          <button
            onClick={handleWhatsAppClick1}
            className="mt-4 mx-auto rounded-full flex items-center border-4 py-2 bg-gradient-to-l from-black to-[#333] text-textSave px-7  hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
          >
            <span
              className="gold-text bg-black text-base mb-1 font-black"
              dir="rtl"
            >
              אני רוצה להזמין!
            </span>
          </button>
          <div className="py-2"></div>
        </div>
      </div>

      <div className="max-w-[90%] lg:max-w-[60%] mx-auto my-8 px-2 shadow-2xl shadow-orange-50 bg-transparent border-2 text-white rounded-3xl z-10">
        <div dir="rtl" className="flex flex-col p-6 space-y-6">
          <div className="flex justify-between items-start">
            <h3
              dir="rtl"
              className="gold-text bg-black text-sm font-bold rounded-lg"
            >
              מינימום 40 איש
            </h3>
            <h3
              dir="rtl"
              className="gold-text bg-black text-sm font-bold rounded-lg"
            >
              100 ש"ח + מע"מ למנה
            </h3>
          </div>

          <h2 className="text-2xl font-bold text-center">דיל בת/ בר מצווה</h2>
          <p className="text-base text-center font-bold">
            מוגש בבופה חופשי עם חימום
            <br />
            הטיגונים נעשים במקום טרי.
          </p>

          <h2 className="text-xl text-center font-black gold-text">
            הדיל כולל:
          </h2>

          <h2 className="text-lg text-center">שניצלונים</h2>
          <h2 className="text-lg text-center">המבורגר על האש</h2>
          <h2 className="text-lg text-center">לחמניות המבורגר</h2>
          <h2 className="text-lg text-center">
            ירקות: עגבניות / מלפפון חמוץ / בצל / רצועות חסה
          </h2>
          <h2 className="text-lg text-center">רטבים: מיונז / BBQ / קטשופ</h2>
          <h2 className="text-lg text-center">צ'יפס וכדורי פירה</h2>
          <h2 className="text-lg text-center">שתיה: תפוזים ולימונדה</h2>
          <h2 className="text-lg text-center">קינוח: גלידה אישית</h2>
          <h2 className="text-lg text-center">כולל כלים חד פעמי איכותי</h2>
          <h2 className="text-lg text-center">
            אפשרות לשולחן קינוחים עשיר בתשלום
          </h2>

          <button
            onClick={handleWhatsAppClick2}
            className="mt-4 mx-auto rounded-full flex items-center border-4 py-2 bg-gradient-to-l from-black to-[#333] text-textSave px-7 hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
          >
            <span
              className="gold-text bg-black text-base mb-1 font-black"
              dir="rtl"
            >
              אני רוצה להזמין!
            </span>
          </button>
          <div className="py-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Deals;
